import LabRepository from "./LabRepository";

const resource = "/sample";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params: params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { data: { id: payload } });
  },
  getAnalytes(id) {
    return LabRepository.get(`${resource}/${id}/analytes`);
  },
  getTestPackageSamples(id) {
    return LabRepository.get(`${resource}/${id}/test-package-samples`);
  },
  getAllSent() {
    return LabRepository.get(`${resource}/sent`);
  },
  getAllReceived() {
    return LabRepository.get(`${resource}/received`);
  },
  getAllOpen() {
    return LabRepository.get(`${resource}/open`);
  },
  getAllInProgress() {
    return LabRepository.get(`${resource}/in-progress`);
  },
  getAllComplete() {
    return LabRepository.get(`${resource}/complete`);
  },
  updateStatus(id, status) {
    return LabRepository.put(`${resource}/${id}/status`, { status });
  },
  fromPublicIdentifier(id) {
    return LabRepository.get(`${resource}/pid/${id}`);
  },
};
